<script setup>
import { twMerge } from "tailwind-merge";

const props = defineProps({
    animated: {
        type: Boolean,
        required: false,
        default: false,
    },
    class: String,
});
</script>

<template>
    <div
        :class="
            twMerge(
                [
                    props.animated ? 'animate-pulse bg-gray-300 dark:bg-gray-800' : 'bg-gray-100 dark:bg-gray-900',
                    'w-full h-6 rounded-lg flex items-center justify-center',
                ],
                props.class
            )
        ">
        <slot />
    </div>
</template>
